var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile teas-my-todo-div" }, [
    _c(
      "div",
      { staticClass: "search" },
      [
        _c("van-search", {
          attrs: { shape: "round", placeholder: "搜索" },
          on: { input: _vm.search },
          model: {
            value: _vm.keywords,
            callback: function ($$v) {
              _vm.keywords = $$v
            },
            expression: "keywords",
          },
        }),
      ],
      1
    ),
    _vm.dataList.length > 0
      ? _c(
          "div",
          { staticClass: "teas-my-todo-main" },
          [
            _c(
              "van-pull-refresh",
              {
                on: { refresh: _vm.onRefresh },
                model: {
                  value: _vm.refreshing,
                  callback: function ($$v) {
                    _vm.refreshing = $$v
                  },
                  expression: "refreshing",
                },
              },
              [
                _c(
                  "van-list",
                  {
                    attrs: {
                      finished: _vm.finished,
                      error: _vm.error,
                      "finished-text": "没有更多了",
                    },
                    on: {
                      "update:error": function ($event) {
                        _vm.error = $event
                      },
                      load: _vm.getList,
                    },
                    model: {
                      value: _vm.loading,
                      callback: function ($$v) {
                        _vm.loading = $$v
                      },
                      expression: "loading",
                    },
                  },
                  _vm._l(_vm.dataList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: "teas-my-todo-item" + index,
                        staticClass: "teas-my-todo-item",
                        on: {
                          click: function ($event) {
                            return _vm.rowClick(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "teas-my-todo-item-top" }, [
                          _c("div", { staticClass: "item-name" }, [
                            _vm._v(_vm._s(item.moduleName || "")),
                          ]),
                          _c("div", { staticClass: "item-content" }, [
                            _vm._v(_vm._s(item.content || "")),
                          ]),
                        ]),
                        _c("div", { staticClass: "teas-my-todo-item-bottom" }, [
                          _c(
                            "div",
                            {
                              class:
                                parseInt(item.status) == 1
                                  ? "item-status-read"
                                  : "item-status-unread",
                            },
                            [_vm._v(_vm._s(item.statusText || ""))]
                          ),
                          item.sendUserName && item.sendUserName.length > 0
                            ? _c("div", { staticClass: "item-publishname" }, [
                                _c("span", {
                                  staticClass:
                                    "iconfont icon-tab-mine item-icon",
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(item.sendUserName || "")),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "teas-my-todo-main" },
          [_c("van-empty", { attrs: { description: "暂无数据" } })],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }